import { render, staticRenderFns } from "./privacy-preview.vue?vue&type=template&id=315480f0&"
import script from "./privacy-preview.vue?vue&type=script&lang=js&"
export * from "./privacy-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports